import { render, staticRenderFns } from "./HealthConditionDetails.vue?vue&type=template&id=388bfc4a&"
import script from "./HealthConditionDetails.vue?vue&type=script&lang=js&"
export * from "./HealthConditionDetails.vue?vue&type=script&lang=js&"
import style0 from "./HealthConditionDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports